import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { ServerGroups, DashboardServer } from '../../../interfaces/DashboardServer.interface';
import { GroupServersModalComponent } from 'libs/portal/src/modules/tools/group-servers-modal/group-servers-modal.component';
import { Subscription } from 'rxjs';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';

@Component({
  selector: 'app-relay-dashboard',
  templateUrl: './relay-dashboard.component.html',
  styleUrls: ['./relay-dashboard.component.scss'],
})
export class RelayDashboardComponent implements OnInit, OnDestroy {
  authSubscription: Subscription;
  obfuscateDetails = false;

  groupNames: string[] = [];
  serverGroups: ServerGroups[] = [];
  serverData: Array<DashboardServer> = [];
  loading = false;
  navRoutes = [
    {
      imgSrc: '../../../../../assets/img/barAndLineChart.png',
      title: 'Ports Management',
      description: '',
      route: '/Relay/Dashboard/PortsManagement',
    },
  ];
  constructor(private genericService: GenericService, private endpoints: Endpoints, private router: Router, private auth: UserRightsService, private tools: ToolsService) {}

  ngOnInit() {
    this.loading = true;
    this.getAllServers();
    this.authSubscription = this.auth.GetUser().subscribe((user) => {
      const prev = this.obfuscateDetails;
      if (user.isObfuscated) {
        this.obfuscateDetails = true;
      } else {
        this.obfuscateDetails = false;
      }

      if (prev != this.obfuscateDetails) {
        this.loading = true;
        this.serverGroups = [];
        this.groupNames = [];
        this.serverData = [];

        this.getRelayDashboardInfo();
      } else {
        this.getRelayDashboardInfo();
      }
    });
  }

  getRelayDashboardInfo() {
    this.genericService.GET(this.endpoints.GET_RELAY_GROUPS).subscribe(
      (data: Object) => {
        let serverArray = data['body'];
        if (serverArray) {
          serverArray.forEach((element: ServerGroups) => {
            if (element.GroupName != '') {
              if (this.obfuscateDetails) {
                element.OriginalName = element.GroupName;
                element.GroupName = this.tools.Obfuscate(element.GroupName, 'Group ', 4);
                element.Servers.forEach((server) => {
                  server.OriginalName = server.Name;
                  server.Name = this.tools.Obfuscate(server.Name, 'Server ', 4);
                });
              }
              this.serverGroups.push(element);
              this.groupNames.push(element.GroupName);
            } else {
              element.GroupName = 'Unassigned';
              this.serverGroups.push(element);
            }
          });
        }
        this.loading = false;
      },
      (error: any) => {
        console.log(error);
      },
    );
  }

  getAllServers() {
    this.genericService.GET(this.endpoints.GET_RELAY_SERVERS('', 100, null, null, null)).subscribe((res) => {
      this.serverData = res['body'];
    });
  }

  ngOnDestroy(): void {
    this.authSubscription.unsubscribe();
  }

  GoToPage(url: string) {
    this.router.navigateByUrl(url);
  }

  chipClick(event: any, groupName: string) {
    sessionStorage.setItem('relayDashboardSelection', JSON.stringify({ isGroup: false, groupName: groupName, serverName: event.ID }));
    this.router.navigate(['Relay/Dashboard/Details']);
  }

  redirect(event: Event, groupName: string) {
    event.stopPropagation();
    sessionStorage.setItem('relayDashboardSelection', JSON.stringify({ isGroup: true, groupName: groupName, serverName: '' }));
    this.router.navigate(['Relay/Dashboard/Details']);
  }
}
